<template>
  <md-table-row>
    <md-table-cell md-label="Nazwa">{{ link.name }} </md-table-cell>
    <md-table-cell md-label="Link" ref="refLink"
      ><p class="ellipsis">
        {{ link.link }}
      </p>
    </md-table-cell>
    <md-table-cell>
      <a href.prevent="#" class="copy-btn" @click="copyLink">
        <md-icon>file_copy</md-icon>
      </a>
      <a href.prevent="#" class="copy-btn" @click="deleteExternalLink(link.id)">
        <md-icon>delete</md-icon>
      </a>
    </md-table-cell>
  </md-table-row>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ExternalLinkItem',
  props: {
    link: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions(['deleteExternalLink']),
    copyLink() {
      const $el = this.$refs.refLink.$el.querySelector(
        '.md-table-cell-container'
      )
      const selection = window.getSelection()
      const range = document.createRange()
      range.selectNodeContents($el)
      selection.removeAllRanges()
      selection.addRange(range)
      document.execCommand('Copy')
      this.$message('Skopiowano do schowka')
    },
  },
}
</script>

<style scoped>
.ellipsis {
  max-width: 50ex;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
